import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-4",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "bg-accent p-3" }
const _hoisted_3 = { key: 1 }

import { pdsBlobUrl } from '#shared/cms/blob'
import type { AmaPlatforms, AmaPost, AmaPublishedLinks } from '#shared/cms/records'

interface AmaEntry {
  rkey: string
  uri: string
  cid: string
  status: 'unanswered' | 'answered'
  question: string
  posts: AmaPost[]
  platforms?: AmaPlatforms
  publishedLinks?: AmaPublishedLinks
  image?: unknown
  imageDimensions?: { width: number, height: number }
  backgroundStyle?: string
  createdAt: string
  answeredAt?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'AMA - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ statusCode: 404, statusMessage: 'Missing rkey.' })
}

const { data, loading } = useAdminFetch<AmaEntry>(`/api/admin/ama/${rkey.value}`, {
  watch: false,
})

// Build a public PDS URL for an already-stored image so the generator can
// show the previously-published version as the initial preview.
const { atproto } = useRuntimeConfig().public
const initialImagePreviewUrl = computed(() => pdsBlobUrl(atproto?.service, atproto?.did, data.value?.image))

return (_ctx: any,_cache: any) => {
  const _component_AdminSkeleton = _resolveComponent("AdminSkeleton")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminAmaAnswer = _resolveComponent("AdminAmaAnswer")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Answer" }, {
    default: _withCtx(() => [
      (!_unref(data) && _unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("section", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-sm text-muted mb-1" }, " Question ", -1)),
              _createElementVNode("p", null, [
                _createVNode(_component_AdminSkeleton, { class: "bg-muted/20 w-3/5" })
              ])
            ]),
            _createVNode(_component_AdminSkeletonForm, {
              fields: ['textarea', 'checkbox'],
              "width-class": ""
            })
          ]))
        : (_unref(data))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_AdminAmaAnswer, {
                rkey: _unref(data).rkey,
                question: _unref(data).question,
                "created-at": _unref(data).createdAt,
                "initial-posts": _unref(data).posts,
                "initial-platforms": _unref(data).platforms,
                "initial-published-links": _unref(data).publishedLinks,
                "initial-image-preview-url": _unref(initialImagePreviewUrl),
                "initial-image-dimensions": _unref(data).imageDimensions,
                "initial-background-style-id": _unref(data).backgroundStyle
              }, null, 8, ["rkey", "question", "created-at", "initial-posts", "initial-platforms", "initial-published-links", "initial-image-preview-url", "initial-image-dimensions", "initial-background-style-id"])
            ]))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})